<template>
  <zord-button
    label="Back"
    type="button"
    @click="clearResultSelection"
    is-basic
    has-leading-icon
  >
    <template v-slot:leadingIcon>
      <i class="fal fa-chevron-left" />
    </template>
  </zord-button>

  <zord-card is-padded>
    <header>
      <zord-heading
        :level="1"
        :text="t('questions.form.header')"
      />
      <p>{{ t('questions.form.choose_topic.subheader') }}</p>
    </header>

    <div class="topics">
      <zord-button v-for="topic in topics"
        :key="topic.id"
        type="button"
        :data-topic-id="topic.id"
        @click="onTopicSelection"
        :label="topic.name"
        is-fluid
        is-rounded
      />
    </div>
  </zord-card>
</template>

<script>
import { t } from '@/javascripts/config/i18n'
import {
  ZordButton,
  ZordCard,
  ZordHeading
} from '@/javascripts/components/zord'

export default {
  name: 'ChooseTopic',
  data() {
    return {
      t,
      formattedTopics: []
    }
  },
  props: {
    topics: {
      type: Array,
      default: []
    }
  },
  components: {
    ZordButton,
    ZordCard,
    ZordHeading
  },
  methods: {
    clearResultSelection() {
      this.$parent.resetSelectedResult()
    },
    onTopicSelection({ currentTarget }) {
      const { topicId } = currentTarget.dataset
      const selectedTopic = this.topics.find(topic => topic.id === Number(topicId))

      this.$parent.setSelectedTopic(selectedTopic)
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    margin-bottom: var(--spacing-xl);
  }

  .topics {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
  }
</style>
